import "./Checkout.module.css";
import Navigation from "@/reusable_sections/Header";
import Checkout from "./sections/Checkout";
import Footer from "@/reusable_sections/Footer";
export default function CheckoutPage() {
  return <div>
      <Navigation />
      <Checkout />
      <Footer />
    </div>;
}